import { BsImage } from 'react-icons/bs';
import styled from 'styled-components';

const MainContainer = styled.div`
  user-select: none;
`;

const Label = styled.label`
  color: ${({ $textColor }) => $textColor};
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.4px;
  margin-top: 12px;
  color: ${({ theme }) => theme.COLOR_GREY_TEXT};
`;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.COLOR_BG_DARK};
  width: min-content;
  height: 48px;
  width: 48px;
  margin: 4px 0px;
`;

const NoThumbnail = styled(BsImage)`
  color: ${({ theme }) => theme.COLOR_GREY4};
  width: 28px;
  height: 28px;
`;

const AlignImageElements = styled.div`
  align-items: center;
  display: flex;
  margin-bottom: 24px;
`;

const Thumbnail = styled.img`
  width: 48px;
  height: 48px;
  margin: 4px 0;
  border-radius: 4px;
`;

const ThumbnailPicker = styled.input``;

const UploadImageThumbnailStyle = {
  Label,
  IconContainer,
  NoThumbnail,
  MainContainer,
  AlignImageElements,
  Thumbnail,
  ThumbnailPicker,
};

export default UploadImageThumbnailStyle;
